import { useState } from "react";
import { Input, Button, List, Flex } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const OptionsBuilder = ({ value = [], onChange }) => {
    const [options, setOptions] = useState(value);
    const [inputValue, setInputValue] = useState("");

    const addOption = () => {
        if (!inputValue.trim()) return;

        const newOptions = [...options, inputValue.trim()];
        setOptions(newOptions);
        onChange?.(newOptions);
        setInputValue("");
    };

    const removeOption = (index) => {
        const newOptions = options.filter((_, i) => i !== index);
        setOptions(newOptions);
        onChange?.(newOptions);
    };

    return (
        <div className="options-builder">
            {/* Add Option */}
            <Flex gap={8}>
                <Input
                    placeholder="Enter an option"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onPressEnter={addOption}
                />
                <Button icon={<PlusOutlined />} onClick={addOption} />
            </Flex>

            {/* Options List */}
            {options?.length > 0 && (
                <List
                    dataSource={options}
                    renderItem={(item, index) => (
                        <List.Item
                            className="option-item"
                            actions={[
                                <DeleteOutlined
                                    key="delete"
                                    className="delete-icon"
                                    onClick={() => removeOption(index)}
                                />,
                            ]}
                        >
                            {item}
                        </List.Item>
                    )}
                />
            )}

        </div>
    );
};

export default OptionsBuilder;